import {Component} from "react";
import './PopUp.css'

export default class PopUp extends Component {
    constructor(props) {
        super(props);
        this.text = props.text
    }

    render() {
        return (
            <div className={'popUpOverlay'}>
                <div className={'popUpBox'}>
                    <h1 className={'popUpText'}>{this.text}</h1>
                </div>
            </div>
        );
    }
}